import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { LogErrors } from './../../../../utilities/LogErrors'
import { useLanguage } from './../../../../utilities/LanguageContext'

//Funciones personalizadas
import { GetCourses } from './../../../../utilities/BL/Student/Courses'
import { GetResults } from './../../../../utilities/BL/Student/Results'


//Componentes comunes generales
//import { Header } from './../../../Header/Header'
import { Header } from './../../../Header/V2/Header'
import { Section } from './../../Section'
import { Loading } from './../../../Common/Loading'
import { GoToTop } from './../../../Common/GoToTop'
import { Button } from './../../../Common/Button'
//import { Result } from './../Result'
import { Result } from './../V2/Result'
import { HELP_TYPE } from './../../../../utilities/EL/HelpType'

//Componentes del proyecto
//import { Tile } from './../Tile'
//import { Credits } from './../../../Common/Credits/Credits'

// Funciones comunes generales
import { GetCurrentCenter as BLGetCurrentCenter, GetNickname as BLGetNickname, SaveCourseToShow } from './../../../../utilities/BL/Navigation'
import { SideMenu } from '../../../Menu/V2/SideMenu'
import { BodyWithSideMenu } from '../../BodyWithSideMenu'
import { WEBPAGES } from './../../../../utilities/EL/WebPages'
import { TYPE_PROPOSITION_VALUE } from '../../../../utilities/EL/TypePropositionValue'

import { ROLES } from './../../../../utilities/EL/Roles'


const Ztudiant = ({ session, setSession, theme, setTheme, centerSelected, roleSelected }) => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true)
    const [theTheme] = useState(theme)

    // const [courses, setCourses] = useState([])
    // const [approvedCourses, setApprovedCourses] = useState([])
    // const [results, setResults] = useState([])

    const [courses, setCourses] = useState(null)
    const [approvedCourses, setApprovedCourses] = useState(null)
    const [results, setResults] = useState(null)

    const [currentCenter, setCurrentCenter] = useState(null)
    const [nickname, setNickname] = useState(null)

    const typePropositionValue = {
        ZTUDENT: 1,
        INSTRUCTOR: 2
    }

    const typeHelp = {
        ZTUDENT: {
            DASHBOARD: 1
        },
        INSTRUCTOR: {
            DASHBOARD: 2
        }
    }

    const GoToNextView = async (course, goToQuickAccessInstrument = false) => {
        try {
            const response = await SaveCourseToShow(session, course, goToQuickAccessInstrument)
            
            if (response.success) {
                setSession(response.data)
                navigate('/course')
            }
        } catch (error) {
            await LogErrors('GoToNextView - Ztudiant', error)
            return { success: false, message: '' }
        }
    }

    /**
     * Obtiene un arreglo de objetos con los idCourse únicos
     * @param {Array} evaluations - Lista de evaluaciones con propiedades idCourse
     * @returns {Array<{idCourse: number}>} Lista de objetos únicos por idCourse
     */
    const GetListOfCourses = async (evaluations = []) => {
        try {
            const unique = new Set()
            
            // Recorremos y agregamos solo los idCourse únicos al Set
            evaluations.forEach(evaluation => {
                if (evaluation.idCourse !== undefined) {
                    unique.add(evaluation.idCourse)
                }
            })
            
            // Convertimos el Set en arreglo de objetos
            return Array.from(unique).map(idCourse => ({ idCourse }))
        } catch (error) {
            await LogErrors('GetListOfCourses - Ztudiant', error)
        }
    }

    //Checar cómo mandar a llamar esta función para obtener e imprimir los cursos
    const LoadPage = async () => {
        try {
            document.body.classList.add('BodyComplete')


            const response = await GetCourses(session, centerSelected, roleSelected)
            
            if (response.success) {    
                // setCourses(response.data?.user?.courses?.myCourses ?? [])
                // setApprovedCourses(response.data?.user?.courses?.myApprovedCourses ?? [])

                const myCourses = response.data?.user?.courses?.myCourses
                if (myCourses) {
                    setCourses(myCourses)
                } else {
                    setCourses(null)
                }

                const myApprovedCourses = response.data?.user?.courses?.myApprovedCourses
                if (myApprovedCourses) {
                    setApprovedCourses(myApprovedCourses)
                } else {
                    setApprovedCourses(null)
                }
                

                const results = await GetResults(response.data)
                
                if (results.success) {
                    const evaluations = results?.data?.evaluations

                    if (evaluations) {
                        const listOfCourses = await GetListOfCourses(evaluations)

                        setResults(listOfCourses)
                        //setResults(results.data?.evaluations ?? [])
                    } else {
                        setResults(null)
                    }
                    
                    setSession(results.data)
                } else {
                    setSession(response.data)
                }
            } else {
                //Mostrar mensaje de que no se pudo obtener la info o el error
                // if (response.message !== undefined) {
                //     if (response.message !== '') {
                //         console.log(response?.message) //Mensaje temporal
                //     }
                // }
                console.log(response?.message)
                
                
                const results = await GetResults(session)
                
                if (results.success) {
                    const evaluations = results?.data?.evaluations

                    if (evaluations) {
                        //setResults(results.data?.evaluations ?? [])
                        setResults(evaluations)
                    } else {
                        setResults(null)
                    }

                    setSession(results.data)
                }
            }


            // Obtener info del centro actual para utilizar cierta info en la pantalla
            const responseCenter = await BLGetCurrentCenter()
            
            if (responseCenter.success) {
                let centerId = responseCenter?.data?.id

                if (!centerId) {
                    return
                }

                // Si el dato viene como cadena, convertirlo a entero
                if (typeof centerId === "string") {
                    centerId = parseInt(centerId)
                }
                
                responseCenter.data.id = centerId

                setCurrentCenter(responseCenter.data)
            }


            // Obtener info del alias del usuario para utilizar cierta info en la pantalla
            const responseNickname = await BLGetNickname()
            
            if (responseNickname.success) {
                const nickname = responseNickname?.data

                if (!nickname) {
                    return
                }

                setNickname(nickname)
            }
        } catch (error) {
            await LogErrors('LoadPage - Ztudiant', error)
        } finally {
            setIsLoading(false)
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        LoadPage()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar

    
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <BodyWithSideMenu page={WEBPAGES.ZTUDENT.DASHBOARD} theme={theme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.DASHBOARD} role={ROLES.ZTUDENT}>
                    {/* <Header theme={theTheme} setTheme={setTheme} propositionValue={typePropositionValue.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.DASHBOARD} /> */}
                    <Header theme={theme} setTheme={setTheme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.DASHBOARD} />
                    
                    <main className='Container Dashboard--V2 Container-FullHeight Fonts--PlusJakartaSans'>
                        <p className='Dashboard--V2__Title'>{translate('labels.dashboard.courses.welcome')} <span className='Dashboard--V2__Text--Highlight'>{(nickname && nickname !== '') ? nickname : `${session.user.name} ${session.user.lastName}`} <i className='bi bi-emoji-smile'></i></span></p>
                        {session?.navigation?.center?.name && (
                            <p className='Dashboard--V2__Text Dashboard--V2__Text--Small Dashboard--V2__Text--Hide'>Centro: {session.navigation.center.name}</p>
                        )}
                        {session?.navigation?.username && (
                            <p className='Dashboard--V2__Text Dashboard--V2__Text--Small Dashboard--V2__Text--Hide'>Usuario: {session.navigation.username}</p>
                        )}
                        
                        <p className='Dashboard--V2__SpaceUp'>Ingresa a la sección que desees</p>

                        <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                            {courses && (
                                courses.length > 0 ? (
                                    <>
                                        <p className='Dashboard--V2__Sections__Title'>{translate('labels.dashboard.courses.title')}</p>
                                        <p className='Dashboard--V2__Text--Small Dashboard--V2__Text--Hide'>Total: {courses.length}</p>

                                        <div className='Dashboard--V2__Sections__List'>
                                            {courses.map((course, index) => (
                                                course && (
                                                    <div key={index} className='Dashboard--V2__Sections__List__Items--Ztudent Dashboard--V2__Sections__List__Items--Pink' onClick={() => GoToNextView(course)}>
                                                        {course.tileIconClass && course.tileIconClass !== '' && (
                                                            <figure className='Dashboard--V2__Sections__List__Items--Ztudent__Icon'>
                                                                <i className={`${course.tileIconClass}`}></i>
                                                            </figure>
                                                        )}

                                                        <p className='Dashboard--V2__Sections__List__Items--Ztudent__Subtitle'><i className='bi bi-file-earmark'></i> {course.type === 1 ? translate('labels.dashboard.tiles.examType.certification') : translate('labels.dashboard.tiles.examType.custom')}</p>
                                                        <p className='Dashboard--V2__Sections__List__Items--Ztudent__Title'>{`${course.name}${course?.level && ` nivel ${course.level}` }`}</p>

                                                        <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Ztudent__Buttons' onClick={() => GoToNextView(course)}>
                                                            <i className='bi bi-arrow-right'></i>
                                                        </button>
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <p>{translate('labels.dashboard.courses.empty')}</p>
                                )
                            )}
                        </section>

                        <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                            {results && (
                                results.length > 0 ? (
                                    <>
                                        <p className='Dashboard--V2__Sections__Title'>Mis resultados</p>
                                        <p className='Dashboard--V2__Text--Small Dashboard--V2__Text--Hide'>Total: {results.length}</p>

                                        <div className='Dashboard--V2__Sections__List'>
                                            {results.map((result, index) => (
                                                result && (
                                                    <Result key={index} session={session} result={result} />
                                                )
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <p>Actualmente no tienes resultados.</p>
                                )
                            )}
                        </section>
                    </main>
                </BodyWithSideMenu>
            )}
        </>
    )
}

export { Ztudiant };









{/* <Section textSection={translate('labels.dashboard.courses.title')}>
    {courses && (
        courses.length > 0 ? (
            <Tile elements={courses} session={session} setSession={setSession} />
        ) : (
            <p>{translate('labels.dashboard.courses.empty')}</p>
        )
    )}
</Section>

{approvedCourses && (
    //approvedCourses.length >= 0 && (
        approvedCourses.length > 0 && (
            <Section textSection={translate('labels.dashboard.approvedCourses.title')} classNameSection={'Section-Separation'}>
                <Tile elements={approvedCourses} session={session} setSession={setSession} />
            </Section>
        )
    //)
)}

{results && (
    results.length > 0 ? (
        <Section textSection="Mis resultados" classNameSection={'Section-Separation'}>
            <div className='Tiles HideMoveButton'>
                <Button className={'Tiles-ButtonMoveTile'} iconClass={'bi bi-three-dots-vertical'} />

                {results.map((result, index) => (
                    <Result key={index} session={session} result={result} />
                ))}
            </div>
        </Section>
    ) : (
        <p>Actualmente no tienes resultados.</p>
    )
)} */}